<basetile-renderer #tileRenderer>
  <div target="title">
    <wiz-label [wizLabel]="data.source.trsLabel" [wizTextBehavior]="'truncate'"></wiz-label>
  </div>
  <div target="body">
    <wiz-hgroup width="100%" height="100%" verticalAlign="center">
      <wiz-icon *ngIf="isFD()" height="16px">codifications</wiz-icon>
      <wiz-icon *ngIf="isChron()" height="16px">chronocodes</wiz-icon>
      <wiz-label [wizLabel]="data.source.code" [wizTextBehavior]="'wordWrap'" [wizNbLine]="2"></wiz-label>
    </wiz-hgroup>
  </div>
</basetile-renderer>
